import { cn } from "../../lib/cn";
import { statusClass } from "../../lib/records";

interface StatusPillProps {
  status: string;
  className?: string;
}

export function StatusPill({ status, className }: StatusPillProps) {
  return (
    <span className={cn("status-pill", statusClass(status), className)}>
      {status || "Unspecified"}
    </span>
  );
}
